import { FieldValues, Path, mapRadioCardsField } from '@ninja/utilities';
import { usePlanCategories } from '../../../../app-init-data';

export const usePlanCategoryField = <TForm extends FieldValues>({ field }: { field: Path<TForm> }) => {
	const { planCategories } = usePlanCategories();

	const getField = () =>
		mapRadioCardsField({
			field,
			cards: planCategories.map((p) => ({
				id: p.id,
				label: p.name,
			})),
		});

	return {
		getField,
	};
};
